import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import type { ActiveFilter } from '../hooks/useVenueFilters';

interface ActiveFiltersChipsProps {
  filters: ActiveFilter[];
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

export function ActiveFiltersChips({ filters, onRemove, onClearAll }: ActiveFiltersChipsProps) {
  // Exclude sortBy from visual chips (it's shown in dropdown)
  const visibleFilters = filters.filter((f) => f.key !== 'sortBy');

  // Return null if no active filters to display
  if (visibleFilters.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
      }}
    >
      <Box
        component="span"
        sx={{
          fontSize: '0.875rem',
          fontWeight: 500,
          color: 'text.secondary',
          fontFamily: '"IBM Plex Sans", sans-serif',
        }}
      >
        Active filters:
      </Box>

      {visibleFilters.map(({ key, label, value }) => (
        <Chip
          key={key}
          label={`${label}: ${value}`}
          onDelete={() => onRemove(key)}
          size="small"
          sx={{
            fontFamily: '"IBM Plex Sans", sans-serif',
            fontSize: '0.8125rem',
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            '& .MuiChip-deleteIcon': {
              color: 'text.secondary',
              '&:hover': {
                color: 'error.main',
              },
            },
          }}
        />
      ))}

      <Button
        variant="text"
        size="small"
        onClick={onClearAll}
        sx={{
          fontSize: '0.8125rem',
          textTransform: 'none',
          fontWeight: 500,
          minWidth: 'auto',
          px: 1,
          color: 'text.secondary',
          '&:hover': {
            color: 'text.primary',
            backgroundColor: 'transparent',
            textDecoration: 'underline',
          },
        }}
      >
        Clear all
      </Button>
    </Box>
  );
}
